import type { CaseStudyContent } from './caseDetails';

export const enterpriseSoftwareCase = {
  "eyebrow": "信创软件行业 GEO 案例",
  "summary": "珠三角一家国家级专精特新“小巨人”软件企业，已有金融及政企客户，却在部分 AI 选型回答中缺席。项目聚焦四类产品需求，持续完善真实产品信息。按原案例的监测口径，180 天后综合推荐率由 20% 升至 80%。",
  "duration": "180 天 · 两个季度",
  "keywords": [
    "信创软件GEO",
    "企业级软件",
    "政企采购",
    "AI产品推荐",
    "专精特新"
  ],
  "metrics": [
    {
      "value": "20% → 80%",
      "label": "综合推荐率",
      "note": "约定目标问题与平台监测口径"
    },
    {
      "value": "+60 个百分点",
      "label": "推荐率变化",
      "note": "项目初期与末期对比"
    },
    {
      "value": "180 天",
      "label": "持续优化周期",
      "note": "覆盖两个季度"
    },
    {
      "value": "4 类",
      "label": "核心产品需求",
      "note": "具体品类按原案例保密"
    }
  ],
  "overview": [
    {
      "label": "企业背景",
      "value": "珠三角国家级专精特新“小巨人”企业"
    },
    {
      "label": "主营领域",
      "value": "信创及企业级软件"
    },
    {
      "label": "目标客户",
      "value": "政府、企事业单位及金融机构"
    },
    {
      "label": "销售方式",
      "value": "项目招投标与企业直接采购"
    },
    {
      "label": "竞争场景",
      "value": "与大型科技集团旗下同类软件业务参与选型"
    },
    {
      "label": "优化边界",
      "value": "围绕真实产品能力，不编造数据或排名"
    }
  ],
  "channelsTitle": "优化前：产品有实力，AI 选型缺席",
  "channelsDescription": "原案例关注采购研究中的推荐表现，未披露流量、询盘或成交数据。",
  "channelHeaders": [
    "观察场景",
    "已有基础",
    "信息缺口"
  ],
  "channels": [
    {
      "channel": "产品类目推荐",
      "traffic": "四类实际产品需求",
      "challenge": "部分回答优先列出大型厂商，客户未进入候选名单。"
    },
    {
      "channel": "专业采购研究",
      "traffic": "具备产品与项目经验",
      "challenge": "技术条件、适用场景与交付能力需要被准确理解。"
    },
    {
      "channel": "品牌信息查询",
      "traffic": "已有政企和金融客户",
      "challenge": "细分领域的专业积累未充分转化为公开信息优势。"
    }
  ],
  "painPoints": [
    {
      "title": "集团品牌认知领先",
      "description": "采购方更容易先认识大型集团，再了解其细分产品。"
    },
    {
      "title": "专业资料积累存在差距",
      "description": "企业的真实能力需要有清晰、充分的公开资料支撑。"
    },
    {
      "title": "推荐名单遗漏供应商",
      "description": "初期综合推荐率为 20%，部分目标回答缺少客户产品。"
    },
    {
      "title": "选型信息需要专业校验",
      "description": "金融与政企采购涉及适配、稳定性、交付及维护要求。"
    }
  ],
  "strategies": [
    {
      "step": "策略一",
      "title": "按采购需求划定优化范围",
      "description": "以四类真实产品需求作为研究对象。",
      "items": [
        "观察不指定品牌时的候选厂商",
        "兼顾技术场景与品牌识别"
      ]
    },
    {
      "step": "策略二",
      "title": "让真实产品能力更易理解",
      "description": "依据产品资料与客户确认的信息组织内容。",
      "items": [
        "说明功能、特点及适用条件",
        "内部研究竞争，对外解释自身能力"
      ]
    },
    {
      "step": "策略三",
      "title": "持续监测，按反馈调整",
      "description": "在两个季度内跟踪约定问题的回答变化。",
      "items": [
        "记录品牌提及、推荐与可见信源",
        "依据阶段测试修正信息表达"
      ]
    }
  ],
  "resultsTitle": "优化结果：在目标需求中增加被推荐机会",
  "results": [
    {
      "dimension": "综合推荐率",
      "before": "20%",
      "after": "80%",
      "change": "提升 60 个百分点"
    },
    {
      "dimension": "目标问题表现",
      "before": "部分回答未列出客户产品",
      "after": "约定范围内的推荐表现改善",
      "change": "更多进入选型视野的机会"
    }
  ],
  "businessOutcomes": [
    "结果对应四类目标需求与项目监测范围，不能外推至所有软件问题。",
    "推荐变化不等同于中标或营收增长；采购仍需技术与商务评估。"
  ],
  "takeaways": [
    "先找到产品真正适配的需求，再建设支持选型的信息。",
    "将专业积累整理为可核验的资料，持续观察推荐反馈。",
    "把 AI 可见度与最终业务结果分别衡量。"
  ],
  "disclaimer": "本页根据公开案例整理。客户、具体品类及技术细节沿用原文的匿名处理；推荐率为该项目阶段性监测结果，不代表未来效果。"
} satisfies CaseStudyContent;
